export const UNIFORM_PARAM_PREFIX = `v_POLY_param_`;
